"use client";
import React from "react";
import { CatSkeleton } from "@blocks-react/components/Skeleton";
import { CatLayout } from "blocks-nextjs/blocks-react/components/Layout";
import { CatLayoutSection } from "blocks-nextjs/blocks-react/components/LayoutSection";
import { CatGrid } from "blocks-nextjs/blocks-react/components/Grid";
import { CatGridItem } from "blocks-nextjs/blocks-react/components/GridItem";
import { useBreakpoint } from "@cat-ecom/pcc-components";
import { PAGE_BREAKPOINTS } from "constants/common";
import styles from "./my-equipment-loader.module.scss";
import { v4 as uuid } from "uuid";

export type MyEquipmentLoaderProps = {
  equipments?: number;
  isSearchBar?: boolean;
};

const MyEquipmentLoader = ({
  equipments = 0,
  isSearchBar = true,
}: MyEquipmentLoaderProps) => {
  const loaderCount = Array.from({
    length: Math.max(equipments, 12),
  });
  const isDesktop = useBreakpoint(PAGE_BREAKPOINTS.BLOCKS_LG) || true;

  return (
    <>
      {isDesktop || isDesktop === undefined ? (
        <div className="mb-3">
          <div className="mb-3">
            {isSearchBar && (
              <CatLayout
                className={`${styles["equipment-header__main"]}`}
                data-testid="equipment-layout"
              >
                <CatGrid className={styles["equipment-header__tittle"]}>
                  <CatSkeleton width="261px" />
                </CatGrid>
                <div className={styles["equipment-header__wrapper"]}>
                  <div className={styles["equipment-header__search"]}>
                    <CatSkeleton width="332px" />
                  </div>
                  <div className={`${styles["equipment-header__button"]}`}>
                    <CatSkeleton />
                  </div>
                </div>
              </CatLayout>
            )}
          </div>
          <CatLayout gap="lg">
            <CatLayoutSection>
              <CatGrid variant="1-3up">
                {loaderCount.map(() => {
                  return (
                    <React.Fragment key={uuid()}>
                      <CatGridItem>
                        <div className={styles["equipment-loader__cards"]}>
                          <CatSkeleton />
                        </div>
                      </CatGridItem>
                    </React.Fragment>
                  );
                })}
              </CatGrid>
            </CatLayoutSection>
            <CatLayoutSection>
              <CatSkeleton className={styles["equipment-loader__selected"]} />
              <CatSkeleton className={styles["equipment-loader__selected"]} />
              <CatSkeleton className={styles["equipment-loader__selected"]} />
            </CatLayoutSection>
          </CatLayout>
        </div>
      ) : (
        <div className="mb-2">
          {isSearchBar && (
            <>
              <div className="mb-2 mt-3">
                <div className={styles["equipment-tablet-header__wrapper"]}>
                  <div className={styles["equipment-tablet-header__tittle"]}>
                    <CatSkeleton />
                  </div>
                  <div className={styles["equipment-tablet-header__button"]}>
                    <CatSkeleton />
                  </div>
                </div>
              </div>
              <div
                className={`${styles["equipment-tablet-header__search"]} mb-2`}
              >
                <CatSkeleton />
              </div>
            </>
          )}

          <CatLayout>
            <CatLayoutSection>
              <CatGrid gap="sm">
                {loaderCount.map(() => {
                  return (
                    <React.Fragment key={uuid()}>
                      <CatGridItem
                        className={`${styles["equipment-tablet-header__cards"]}`}
                      >
                        <CatSkeleton />
                      </CatGridItem>
                    </React.Fragment>
                  );
                })}
              </CatGrid>
            </CatLayoutSection>
          </CatLayout>
        </div>
      )}
    </>
  );
};
export default MyEquipmentLoader;

